import moment from 'moment'
import { format } from 'date-fns';

export const parseTime = (sec, hourText = 'hr', minText = 'min', plural = 's') => {
  if (!sec) {
    return `0${minText}`
  }
  const utc = moment.utc(sec * 1000)
  const hours = Number(utc.format('HH'))
  const min = Number(utc.format('mm'))

  let formatted = ''
  if (hours > 0) {
    formatted = `${hours}${hourText}`
    if (hours > 1) {
      formatted += plural
    }
    formatted += ' '
  }

  if (min > 0) {
    formatted += `${min}${minText}`
    if (min > 1) {
      formatted += plural
    }
  }

  return formatted
}

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return ''
  }
  let newPhoneNumber = ''
  for (let i = 0; i < phoneNumber.length; i++) {
    if (i % 2 === 0) {
      newPhoneNumber += ' '
    }
    newPhoneNumber += phoneNumber[i]
  }

  return newPhoneNumber
}

export const getDate = (timestamp) => {
  const UTCDate = timestamp
  if (UTCDate) {
    const day = UTCDate.substring(8, 10)
    const month = UTCDate.substring(5, 7)
    const year = UTCDate.substring(0, 4)
    return `${day}/${month}/${year}`
  }
}

export const getTime = (timestamp) => {
  const UTCDate = timestamp
  if (UTCDate) {
    const time = moment(timestamp).format('HH:mm')
    return time
  }
}
export const formatDateStringForDisplay = (dateString) => {
  const date = new Date(dateString)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Les mois sont indexés à partir de 0
  const year = String(date.getFullYear()).slice(-2)
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}`
}
export function formatDateForInput(date) {
  if (!date) return ''; // Handle empty date case
  return format(new Date(date), "yyyy-MM-dd'T'HH:mm");
}

export function formatDeliveryTimeRange(start, end) {
  if (!start) return ''
  const s = start.substring(0, 5).replace(':', 'h')
  if (!end || start === end) return s
  const e = end.substring(0, 5).replace(':', 'h')
  return `${s} – ${e}`
}
